export default {"src":"/_next/static/media/fire-brigade.fd0f86ce.svg","height":205,"width":184};